import { FC, memo, useCallback } from "react";
import { useSkyViewStore } from "~/features/skyView/store";
import type { PageAnnotation } from "../types";
import { StickyNoteOverlay } from "./StickyNoteOverlay";

interface PageStickyNotesProps {
  annotations: PageAnnotation[];
  onContentChange: (id: string, content: string) => void;
  onColorChange: (id: string, color: string) => void;
  onIconChange: (id: string, icon: string) => void;
  onTitleChange?: (id: string, title: string) => void;
  onPositionChange?: (id: string, positionX: number, positionY: number) => void;
  onDelete: (id: string) => void;
  isViewOnly: boolean;
  rotation?: number;
  pageNumber?: number;
}

const PageStickyNotesComponent: FC<PageStickyNotesProps> = ({
  annotations,
  onContentChange,
  onColorChange,
  onIconChange,
  onTitleChange,
  onPositionChange,
  onDelete,
  isViewOnly,
  rotation = 0,
  pageNumber,
}) => {
  const activeAnnotationId = useSkyViewStore(
    (state) => state.activeAnnotationId
  );
  const setActiveAnnotationId = useSkyViewStore(
    (state) => state.setActiveAnnotationId
  );

  const handleToggleExpand = useCallback(
    (id: string) => {
      setActiveAnnotationId(activeAnnotationId === id ? null : id);
    },
    [activeAnnotationId, setActiveAnnotationId]
  );

  if (annotations.length === 0) {
    return null;
  }

  return (
    <>
      {annotations.map((annotation) => (
        <StickyNoteOverlay
          key={annotation.id}
          annotation={annotation}
          isExpanded={activeAnnotationId === annotation.id}
          onToggleExpand={handleToggleExpand}
          onContentChange={onContentChange}
          onColorChange={onColorChange}
          onIconChange={onIconChange}
          onTitleChange={onTitleChange}
          onPositionChange={onPositionChange}
          onDelete={onDelete}
          isViewOnly={isViewOnly}
          rotation={rotation}
          pageNumber={pageNumber}
        />
      ))}
    </>
  );
};

export const PageStickyNotes = memo(PageStickyNotesComponent);
PageStickyNotes.displayName = "PageStickyNotes";
